var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
          _vm.$style.button,
          _vm.outline && _vm.$style.outline,
          _vm.outlineBlue && _vm.$style.outlineBlue,
          _vm.lightBlue && _vm.$style.lightBlue,
          _vm.sm && _vm.$style.sm ],attrs:{"disabled":_vm.disabled},on:{"click":function () { return _vm.$emit('click'); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }